import { cn } from '@/shared/utils';
import type { ComponentType, ReactNode, SVGProps } from 'react';

interface Props {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  labelIcon?: ReactNode;
  children?: ReactNode;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
}

export const ActionMenuItemContent = ({
  icon: Icon,
  label,
  labelIcon,
  children,
  className,
  iconClassName,
  labelClassName,
}: Props) => (
  <div className={cn('flex items-center gap-[1.6rem] w-full', className)}>
    {Icon && (
      <div
        className={cn(
          'w-[2.4rem] h-[2.4rem] flex items-center justify-center',
          iconClassName
        )}>
        <Icon className={cn('size-[2.4rem] text-primary', iconClassName)} />
      </div>
    )}

    {labelIcon ? (
      <span className="flex flex-1 items-center gap-[0.4rem]">
        {labelIcon}
        <span className={cn('headline4 text-primary', labelClassName)}>
          {label}
        </span>
      </span>
    ) : (
      <span className={cn('headline4 text-primary flex-1', labelClassName)}>
        {label}
      </span>
    )}

    {children}
  </div>
);
